import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Container from "../components/container"
import Page from "../components/page"
import styled from "@emotion/styled"
import faker from "faker"

const Styles = styled.div`
padding: 84px 0px;
  min-height: 100vh;


  .my-snippets {
    display: grid;
    grid-gap: 24px;
    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));

    .card {
      border-radius: 4px;
    }
  }
`

export default class extends React.Component {
  constructor() {
    super()
    this.state = {}
  }

  render() {
    let courses = [
    ]
    return (
      <Layout path="snippets">
        <SEO title="Snippets" />
        <Styles>
            <Container>
              <div className="title">Snippets</div>

              <div className="subtitle">
                Coming soon... 
                
              </div>

              <div className="my-snippets">
                {courses.map(el => {
                  return (
                    <div>
                      <div className="card">
                        <div className="card-image">
                          <img src="https://picsum.photos/600/380"></img>
                        </div>
                        <div className="card-content">
                          <b style={{ marginRight: 4 }}>{el.title}</b>
                          <span style={{ marginRight: 4 }}>by</span>

                          <span>{el.author}</span>
                        </div>
                      </div>
                    </div>
                  )
                })}
              </div>
            </Container>
        </Styles>
      </Layout>
    )
  }
}
